import React from 'react';
import { Paper, Box, Typography, Divider } from '@mui/material';

const SubTitleTemplate = ({ children, title }) => {
  return (
    <>
      <Paper
      variant="outlined"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          my:1
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            backgroundColor:'#616161',
            color:'#fff'
          }}
        >
          <Typography variant="subtitle2" component="div">
            {title}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            mt: 1,
            px: 2,
            pb:2,
          }}
        >
          {children}
        </Box>
      </Paper>
    </>
  );
};

export default SubTitleTemplate;
